// Bet actions
export const SELECT_RACING_BET_TYPE = 'SELECT_RACING_BET_TYPE';
export const TOGGLE_BETTING_TYPE_BUTTON_DISPLAYED = 'TOGGLE_BETTING_TYPE_BUTTON_DISPLAYED';
export const ADD_MULTIBET_SELECTION = 'ADD_MULTIBET_SELECTION';
export const REMOVE_MULTIBET_SELECTION = 'REMOVE_MULTIBET_SELECTION';
export const TOOGLE_BOX_BETS = 'TOOGLE_BOX_BETS';



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/modules/racing/constants/actionTypes.js